import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { MarkersInfoColors } from "../WinLineInfoMarkers";

export class LuckyIce40_Responsive extends SlotGameType1_Responsive {


    protected override helpFactory: IHelpFactory = new LuckyIce40HelpFactory();
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "LuckyIce40");

        this.spinnableReelsParams.topBorderWidth = 8;
        this.spinnableReelsParams.bottomBorderWidth = 8;
    }


    //SEND COLOR FOR RSA 
    protected override color: RewardColor =
        {
            color: "#0A7CBF",
            coloroutherStroke: "black",
            colorinnerStroke: "#031333",
        }
}


//Help Colorized
class LuckyIce40HelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new LuckyIce40Help(params);
    }
}

class LuckyIce40Help extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(6, 42, 115),rgb(8, 61, 166), rgb(7, 86, 242),rgb(8, 61, 166),rgb(6, 42, 115)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}
//}